import React, { useEffect, useState } from "react";
import { CircularProgress, Box } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { serviceProviderInfo } from "../apis";

const ServiceProvideInfoSuccess = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const user = JSON.parse(localStorage.getItem("user-info"));
  const info = JSON.parse(localStorage.getItem("info"));
  const userName = user.fullName;
  const userID = user?.googleId ? user.googleId : user._id;

  useEffect(() => {
    const setData = async () => {
      const data = await serviceProviderInfo({
        serviceProviderId: userID,
        personalInfo: info.personalInfo,
        expertise: info.expertise,
        documents: info.documents,
        connectAccountId: id,
      });
      if (data) {
        let user = JSON.parse(localStorage.getItem("user-info"));
        user.infoFilled = true;
        localStorage.setItem("user-info", JSON.stringify(user));
        navigate("/service-provider/under-review");
      }
    };
    setData();
  }, []);
  return (
    <Box
      sx={{ display: "flex" }}
      justifyContent="center"
      alignItems="center"
      style={{ height: "100vh" }}
    >
      <CircularProgress disableShrink />
    </Box>
  );
};

export default ServiceProvideInfoSuccess;
